'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _radium = require('radium');

var _reactRedux = require('react-redux');

var _configureStore = require('./configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

var _WMCompanyPage = require('./components/WMCompanyPage');

var _WMCompanyPage2 = _interopRequireDefault(_WMCompanyPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configureStore2.default)();

var WMCompanyPagesSPA = function WMCompanyPagesSPA(_ref) {
	var companyNumber = _ref.companyNumber,
	    csrf = _ref.csrf,
	    compact = _ref.compact,
	    isPublic = _ref.isPublic;

	return _react2.default.createElement(
		_radium.StyleRoot,
		null,
		_react2.default.createElement(
			_reactRedux.Provider,
			{ store: store },
			_react2.default.createElement(_WMCompanyPage2.default, {
				companyNumber: companyNumber,
				csrf: csrf,
				compact: compact,
				isPublic: isPublic
			})
		)
	);
};

var _default = WMCompanyPagesSPA;
exports.default = _default;


WMCompanyPagesSPA.propTypes = {
	companyNumber: _propTypes.PropTypes.string.isRequired,
	csrf: _propTypes.PropTypes.string.isRequired,
	compact: _propTypes.PropTypes.bool,
	isPublic: _propTypes.PropTypes.bool
};

WMCompanyPagesSPA.defaultProps = {
	isPublic: false
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(store, 'store', 'src/WMCompanyPagesSPA.build.js');

	__REACT_HOT_LOADER__.register(WMCompanyPagesSPA, 'WMCompanyPagesSPA', 'src/WMCompanyPagesSPA.build.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/WMCompanyPagesSPA.build.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/WMCompanyPagesSPA.build.js
// module id = Geuy
// module chunks = 62 63